import { render } from "./Landing.vue?vue&type=template&id=051daefe"
import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Landing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "051daefe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('051daefe', __exports__)) {
    api.reload('051daefe', __exports__)
  }
  
  module.hot.accept("./Landing.vue?vue&type=template&id=051daefe", () => {
    api.rerender('051daefe', render)
  })

}


export default __exports__